export default class WelcomePageHeroBanner {
    public titleText: string;
    public linkText: string;
    public linkUrl: string;
    public linkUrlTarget: string;
    public bannerBackgroundImage: string;
  
    constructor() {
      this.titleText = "";
      this.linkText = "";
      this.linkUrl = "";
      this.linkUrlTarget = "";
    }
  }


// WEBPACK FOOTER //
// ./src/api/welcomePageHeroBannerEntity.ts